import React, { useState, useEffect, useRef } from "react";
import { Container } from "./styles";
import CustomButton from "../general/CustomButton";
import TableLarge from "../general/TableLarge";
import EditionTabs from "../general/EditionTabs";
import { useModal } from "../../hooks/useModal";
import useNotifications from "../../hooks/useNotification";
import Modal from "../general/Modal";
import { useLocation, useHistory } from "react-router-dom";
import { getDataTable, updateData } from "./utils";
import CustomNotification from "../general/CustomNotification";
import { useStore } from "../../stores/useStore";
import { useMultipleEditionStore } from "../../stores/useMultipleEditionStore";
import Loading from "../general/loading";

const MultipleEdition = () => {
  const { notifications, addNotification, deleteNotification } =
    useNotifications();
  const { modalData, openModal, closeModal, handleCancelClick } = useModal();
  const [inputValue, setInputValue] = useState("");
  const [rejectMessage, setRejectMessage] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedSection, setSelectedSection] = useState("description");
  const location = useLocation();
  const { articles } = location.state || {};
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const tableLeftRef = useRef(null);
  const [currentData, setCurrentData] = useState({
    headerBaseData: [],
    headerSectionData: [],
    initialData: [],
    descriptionsData: [],
  });
  const [initialCache, setInitialCache] = useState({
    initialData: [],
    headerBaseData: [],
  });

  const DESCRIPTION_ATTRIBUTES_DISABLED = [7605];

  const fetchDescriptions = async () => {
    const { initialData, descriptionsData, headerBaseData, headerSectionData } =
      await getDataTable(
        selectedSection,
        initialCache.initialData,
        initialCache.headerBaseData,
        articles,
      );
    if (
      selectedSection === "description" &&
      !initialCache.initialData.length &&
      !initialCache.headerBaseData.length
    ) {
      setInitialCache({ initialData, headerBaseData });
    }
    setCurrentData({
      headerBaseData,
      headerSectionData,
      initialData,
      descriptionsData,
    });
  };

  useEffect(() => {
    let isCancelled = false;

    const loadData = async () => {
      setIsLoading(true);
      try {
        const response = await getDataTable(
          selectedSection,
          initialCache.initialData,
          initialCache.headerBaseData,
          articles
        );

        if (response.initialData?.length > 0 && initialCache.initialData.length === 0) {
          setInitialCache({
            initialData: response.initialData,
            headerBaseData: response.headerBaseData,
          });
        }

        if (!isCancelled) {
          setCurrentData({
            headerBaseData: response.headerBaseData || [],
            headerSectionData: response.headerSectionData || [],
            initialData: response.initialData || [],
            descriptionsData: response.descriptionsData || [],
          });
        }
      } catch (error) {
        if (!isCancelled) console.error("Error al cargar datos:", error);
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    loadData();

    return () => {
      isCancelled = true;
    };
  }, [selectedSection, articles]);

  const storedData = useStore((state) => state.currentData);
  const { articleID } = useStore();

  const { multipleEditionData } = useMultipleEditionStore();

  const updateSection = async (editedFields) => {
    const storedUser = sessionStorage.getItem("user");
    const userId = storedUser ? JSON.parse(storedUser).id_user : null;
    const version = 1;

    if (!userId) {
      throw new Error("Usuario no encontrado");
    }

    const notApprovedAttributes = [];
    const rejectedAttributes = [];
    const emptyAttributes = [];

    multipleEditionData.forEach((item) => {
      item.articleData.forEach((attribute) => {
        if (attribute.isApproved === undefined) {
          const attrName =
            currentData.descriptionsData[0]?.item.attributes.find(
              (attr) => attr.attributeId === attribute.id_attribute,
            )?.name || "Desconocido";
          notApprovedAttributes.push(attrName);
        }
        if (attribute.isApproved === 0) {
          rejectedAttributes.push(attribute.id_attribute);
        }
        if (attribute.value === undefined || attribute.value === "") {
          emptyAttributes.push(attribute.id_attribute);
          const attributeName =
            currentData.descriptionsData[0].item.attributes.find(
              (attr) => attr.attributeId === attribute.id_attribute,
            )?.name || "Desconocido";

        }
      });
    });

    let action = "aprobar";
    if (rejectedAttributes.length > 0) {
      action = "rechazar";
    }

    // if (emptyAttributes.length > 0) {
    //   openModal({
    //     className: "modal-missing",
    //     title: "Existen campos vacíos",
    //     text: `No es posible ${action} el servicio si existen campos vacíos, por favor completa los atributos faltantes para continuar.`,
    //     showAccept: false,
    //     buttons: [
    //       {
    //         label: "Entiendo",
    //         onClick: () => {
    //           closeModal();
    //         },
    //         className: "btn-save",
    //       },
    //     ],
    //   });
    //   return;
    // }
    if (notApprovedAttributes.length > 0) {
      openModal({
        className: "modal-missing",
        title: "Faltan atributos por revisar",
        text: `Te faltan ${notApprovedAttributes.length} atributo(s) por revisar, si no se aprueban o rechazan no es posible guardar los datos.
        ${notApprovedAttributes.length <= 10 ? "Los atributos son: \n" + notApprovedAttributes.map((name) => `• ${name}`).join("\n") : " "}`,
        showAccept: false,
        buttons: [
          {
            label: "Entiendo",
            onClick: () => {
              closeModal();
            },
            className: "btn-save",
          },
        ],
      });
      return;
    }
    if (currentData.descriptionsData.length > 0) {
      openModal({
        className: "modal-missing",
        title: "Confirmar acción",
        text: `Estás por ${action} este servicio, ¿Seguro que quieres continuar?`,
        showAccept: false,
        buttons: [
          {
            label: "Cancelar",
            onClick: () => {
              closeModal();
            },
            className: "btn-cancel",
          },
          {
            label: "Continuar",
            onClick: async () => {
              closeModal();
              setIsLoading(true);
              // openModal({
              //   className:"modal-wait",
              //   title: "Espera un poco",
              //   text: "Estamos guardando los cambios, una vez realizados aparecerá una notificación en la parte inferior izquierda",
              //   showAccept: true,
              //   showCancel: false,
              //   onAcceptClick: closeModal,
              //   buttons: []
              // })
              const service = selectedSection;
              try {
                // const articleId = editedFields[0].articleId;
                // const articleData = editedFields.reduce((acc, item) => {
                //   const camposTransformados = Object.entries(item.fields).map(
                //     ([attributeId, detalles]) => ({
                //       attributeId,
                //       value: detalles.value,
                //       comment: detalles.comment,
                //       isApproved: detalles.isApproved,
                //     })
                //   );
                //   return acc.concat(camposTransformados);
                // }, []);

                const response = await updateData(
                  userId,
                  service,
                  articleID,
                  version,
                  multipleEditionData,
                );
                if (response.success) {
                  fetchDescriptions();
                  addNotification(
                    "success",
                    "Atributos actualizados con éxito",
                  );
                } else {
                  addNotification(
                    "error",
                    "No se pudieron actualizar los atributos",
                  );
                }
              } catch (error) {
                addNotification("error", "Error al actualizar los atribtutos");
                console.error("Error:", error);
              } finally {
                setIsLoading(false);
              }
            },
            className: "btn-save",
          },
        ],
      });
    }
  };

  const scrollToLeft = () => {
    if (tableLeftRef.current) {
      tableLeftRef.current.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <Container>
      <div className="container-head">
        <EditionTabs selectedSection={selectedSection} onSectionChange={(section) => setSelectedSection(section)} />
        <div className="buttons">
          <CustomButton
            className="button-save"
            variant="gray"
            icon="save"
            tooltipText="Guardar"
            onClick={updateSection}
            iconOnly
            showTooltip
          />
          <div className="action_buttons">
            <CustomButton
              onClick={scrollToLeft}
              variant="gray"
              showTooltip
              tooltipText="Regresa al inicio de la tabla"
              icon="arrow_back"
              iconOnly
            ></CustomButton>
            <CustomButton
              variant="gray"
              icon="close"
              tooltipText="Cerrar"
              onClick={() => {
                history.goBack();
              }}
              iconOnly
              showTooltip
            />
          </div>
        </div>
      </div>
      <div className="table">
        {isLoading ? (
          <div className="loader">
            <Loading />
          </div>
        ) : currentData.initialData.length > 0 ? (
          <TableLarge
            ref={tableLeftRef}
            withCheckbox
            initialData={currentData.initialData}
            sectionsData={currentData.descriptionsData}
            headerBaseData={currentData.headerBaseData}
            headerSectionData={currentData.headerSectionData}
            selectedSection={selectedSection}
            onSave={updateSection}
            rejectMessage={rejectMessage}
            disabledAttributes={DESCRIPTION_ATTRIBUTES_DISABLED}
            // openModal={openModal}
            />
        ) : (
          <div className="no-data-message">No se encontraron datos para esta sección.</div>
        )}
      </div>
      {/* <div className="loader">{isLoading && <Loading />}</div> */}

      <CustomNotification
        open={notifications.length > 0}
        alerts={notifications}
        deleteNotification={deleteNotification}
      />
      <Modal {...modalData} onClose={handleCancelClick} />
    </Container>
  );
};

export default MultipleEdition;
